import { render } from "./NbCalculator.vue?vue&type=template&id=a3db12f2&scoped=true"
import script from "./NbCalculator.vue?vue&type=script&lang=js"
export * from "./NbCalculator.vue?vue&type=script&lang=js"

import "./NbCalculator.vue?vue&type=style&index=0&id=a3db12f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3db12f2"]])

export default __exports__